import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function useOnRouteChange(callback: () => void) {
  // This hook will execute the callback function whenever the route changes.Good for modal closing
  // or any other side effects that need to happen on route change.
  const location = useLocation();
  const prevPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;
    if (prevPathRef.current !== currentPath) {
      callback();
      prevPathRef.current = currentPath;
    }
  }, [location.pathname, callback]);
}
